"use client";

import React from "react";
import { useRouter } from "next/navigation";
import { useEvmWallet } from "../../components/EvmWalletProvider";

// Connect button wired to the client-only `WalletProvider`.
// Wallet relays have been removed; this routes users to /login.
export function ConnectWalletButton() {
  const router = useRouter();
  const { isConnected, address } = useEvmWallet();

  const label = isConnected
    ? `${address ? `Wallet ${address.slice(0, 6)}…${address.slice(-4)}` : 'Wallet connected'}`
    : "Connect wallet";

  return (
    <button
      type="button"
      onClick={() => {
        try {
          router.push(isConnected ? "/profile" : "/login");
        } catch {
          // ignore
        }
      }}
      aria-label={isConnected ? 'Open your profile' : 'Connect a wallet'}
      // Premium pass: shares .pr-btn geometry/motion/sheen with the rest of
      // the chrome, but keeps its own emerald "connected" identity so it
      // stays distinguishable from the cyan primary CTA next to it.
      className="pr-btn pr-btn-sm max-w-[11rem] border border-emerald-300/25 bg-[linear-gradient(135deg,rgba(52,211,153,0.96),rgba(16,185,129,0.92))] text-slate-950 shadow-[0_16px_36px_-18px_rgba(16,185,129,0.9)] hover:-translate-y-0.5 hover:shadow-[0_22px_46px_-18px_rgba(16,185,129,1)]"
    >
      <span
        className={`h-1.5 w-1.5 shrink-0 rounded-full ${isConnected ? 'bg-slate-900' : 'bg-slate-900/45'}`}
        aria-hidden="true"
      />
      <span className="truncate">{label}</span>
    </button>
  );
}
